/**
 * constants
 * @type {{SUCCESS: string, ERROR: string, DEFAULT: string}}
 */
export const TYPES = {
	DEFAULT: 'default',
	SUCCESS: 'success',
	ERROR: 'error',
};

export const MODE = {
	MODULE: 'module',
	COMPONENT: 'component'
};


